import styles from "../userManagement.module.css";


export default function UserForm({ userData, handleUserDataChange, imagePreview, handleImageChange, isEditMode }) {
    const genders = ["남", "여", "기타"];

    const currentYear = new Date().getFullYear();
    const months = Array.from({ length: 12 }, (_, i) =>
        String(i + 1).padStart(2, "0")
    );
    const days = Array.from({ length: 31 }, (_, i) =>
        String(i + 1).padStart(2, "0")
    );

    return (
        <div className={styles.publisherFormGrid}>
            <div className={styles.publisherFields}>
                <div className={styles.formRow}>
                    <label>
                        ID (Email)<span className={styles.required}>*</span>
                    </label>
                    <input
                        type="email"
                        name="email"
                        value={userData.email || ""}
                        onChange={handleUserDataChange}
                        required
                        disabled={isEditMode}
                    />
                </div>
                {!isEditMode &&
                    <div className={styles.formRow}>
                        <label>
                            비밀번호<span className={styles.required}>*</span>
                        </label>
                        <input
                            type="text"
                            name="password"
                            value={userData.password || ""}
                            onChange={handleUserDataChange}
                            required
                        />
                    </div>
                }

                <div className={styles.formRow}>
                    <label>
                        이름
                    </label>
                    <input
                        type="text"
                        name="name"
                        value={userData.name || ""}
                        onChange={handleUserDataChange}
                    />
                </div>

                <div className={styles.formRow}>
                    <label>성별</label>
                    <select
                        name="gender"
                        value={userData.gender}
                        onChange={handleUserDataChange}
                        placeholder="성별을 입력해 주세요"
                    >
                        <option value="" disabled>
                            -
                        </option>
                        {genders.map((item, index) => (
                            <option key={index} value={item}>
                                {item}
                            </option>
                        ))}
                    </select>
                </div>

                <div className={styles.formRow}>
                    <label>생년월일</label>
                    <div className={styles.formSelectGroup}>
                        <input
                            type="number"
                            name="birthYear"
                            value={userData.birthYear}
                            onChange={handleUserDataChange}
                            onBlur={(e) => {
                                const val = parseInt(e.target.value, 10);
                                if (!isNaN(val)) {
                                    const clamped = Math.max(1900, Math.min(val, currentYear));
                                    if (val !== clamped) {
                                        handleUserDataChange({ target: { name: "birthYear", value: clamped } });
                                    }
                                }
                            }}
                            min={1900}
                            max={currentYear}
                            placeholder="년도"
                        />

                        <select
                            name="birthMonth"
                            value={userData.birthMonth}
                            onChange={handleUserDataChange}
                        >
                            <option value="">월</option>
                            {months.map((month) => (
                                <option key={month} value={month}>
                                    {month}
                                </option>
                            ))}
                        </select>

                        <select
                            name="birthDay"
                            value={userData.birthDay}
                            onChange={handleUserDataChange}
                        >
                            <option value="">일</option>
                            {days.map((day) => (
                                <option key={day} value={day}>
                                    {day}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className={styles.formRow}>
                    <label>
                        휴대폰번호
                    </label>
                    <input
                        type="text"
                        name="phoneNumber"
                        value={userData.phoneNumber || ""}
                        onChange={handleUserDataChange}
                        // disabled={userData.authMethod === "LOCAL" && isEditMode}
                        disabled={userData.authMethod === "LOCAL" || !isEditMode}
                    />
                </div>

                <div className={styles.formRow}>
                    <label>인증 방법</label>
                    <input
                        type="text"
                        name="authMethod"
                        value={userData.authMethod || "LOCAL"}
                        onChange={handleUserDataChange}
                        disabled
                    />
                </div>
            </div>
            <div className={styles.imageUploader}>
                <label htmlFor="image-upload" className={styles.imageBox}>
                    {imagePreview ? (
                        <img src={imagePreview} alt="Preview" />
                    ) : (
                        "이미지 업로드"
                    )}
                </label>
                <input
                    id="image-upload"
                    type="file"
                    accept="image/*"
                    onChange={handleImageChange}
                    style={{ display: "none" }}
                />
            </div>
        </div>
    );
};